import { CircularProgress } from "@mui/material";

const TextButtonComponet = ({ text, onButtonClick, classStyle = "btn btn-primary",isDisabled = false,style={},loading = false }) => {
    return (<>
        <button type="button" className={classStyle} style={style}  onClick={onButtonClick} disabled={isDisabled || loading}>
            {loading ? <CircularProgress size={18} sx={{ color: "currentColor" }} /> : text}
        </button>
    </>)
}
export default TextButtonComponet;